import Reveal from "@/components/Reveal";
import SectionHeader from "@/components/SectionHeader";
import content from "@/content/siteContent";

export default function ProblemSection() {
  const ch = content.chapters.problem;
  return (
    <section id={ch.id} data-testid="chapter-problem" className="relative mx-auto max-w-7xl scroll-mt-24 px-4 py-24 sm:px-6 lg:px-8 lg:py-32">
      <SectionHeader num={ch.num} label={ch.label} />
      <div className="grid gap-12 lg:grid-cols-2">
        <Reveal>
          <h2 className="font-heading text-2xl font-bold leading-snug tracking-tight sm:text-3xl lg:text-4xl">
            {ch.headlineA}
            <span className="text-plz-orange">{ch.headlineAccent}</span>
          </h2>
        </Reveal>
        <Reveal delay={0.15}>
          <div className="space-y-5 text-base leading-relaxed text-plz-slate sm:text-lg">
            {ch.paragraphs.map((p) => (
              <p key={p.slice(0, 24)}>{p}</p>
            ))}
            <p className="font-heading text-xl font-semibold text-plz-cream">{ch.closing}</p>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
